/**
 * @param {string} dramaStatus
 * @param {number} currentEps
 */
export default function getDramaStatusText(dramaStatus, currentEps) {
  switch (dramaStatus) {
    case '': {
      return '已完結';
    }

    case '連載中': {
      return currentEps ? `連載至第 ${currentEps} 集` : '連載中';
    }

    case '跟播中': {
      return currentEps ? `跟播至第 ${currentEps} 集` : '跟播中';
    }

    default: {
      return dramaStatus;
    }
  }
}
